import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import withBackSupport from 'components/HOCs/withBackSupport';
import withMenu from 'components/HOCs/withMenu';
import withScrollHack from 'components/HOCs/withScrollHack';
import useLeaveFor from 'hooks/useLeaveFor';
import { getIsLoggedInSelector } from 'reducers/profile/selectors';
import { selectPurchasesList } from 'reducers/purchases/selectors';
import { fetchPurchases, loadExtraPurchasedItems, resetAllPurchasesData } from 'actions/purchases';
import NotLoggedStub from './NotLoggedStub';
import PurchasesPage from './Page';

const PurchasesContainer = (props) => {
  const { isLoggedIn, resetAllPurchasesData, ...rest } = props;
  const history = useHistory();

  useLeaveFor(history, (location) => {
    // It clears all data, because all data could be changed outside player
    if (!location.pathname.startsWith('/player')) resetAllPurchasesData();
  });

  return isLoggedIn ? <PurchasesPage {...rest} /> : <NotLoggedStub />;
};

const mapStateToProps = createStructuredSelector({
  isLoggedIn: getIsLoggedInSelector,
  items: selectPurchasesList,
});

export const mapDispatchToProps = {
  fetchPurchases,
  loadExtraPurchasedItems,
  resetAllPurchasesData,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withBackSupport,
  withMenu,
  withScrollHack,
)(PurchasesContainer);
